const reducerConstant = {
  editFirstName: "edit/FIRSTNAME",
  editLastName: "edit/LASTNAME",
  createProject: "create/PROJECT",
  tokenSave: "login/TOKEN_SAVE",
  resetTokenData: "logout/RESET_TOKEN",
  loginRequest: "login/LOGIN",
  socialLoginRequest: "login/LOGIN_SOCIAL",
  loginSuccess: "login/LOGIN_SUCCESS",
  loginFailed: "login/LOGIN_FAILED",
  resetLoginState: "login/RESET",
  verifyEmail: "login/VERIFY",
  verifyEmailSuccess: "login/VERIFY_SUCCESS",
  verifyEmailFailed: "login/VERIFY_ERROR",
  forgotPassword: "login/FORGOT",
  forgotSuccess: "login/FORGOT_SUCCESS",
  forgotFailed: "login/FORGOT_FAILED",
  resendPassword: "forgot/RESEND",
  resendPasswordSuccess: "forgot/RESEND_SUCCESS",
  resendPasswordFailed: "forgot/RESEND_FAILED",
  requestEmailVerify: "signUpConfirm/VERIFY",
  requestEmailVerifySuccess: "signUpConfirm/VERIFY_SUCCESS",
  requestEmailVerifyFailed: "signUpConfirm/VERIFY_FAILED",
  resetSignupConfirm: "signUpConfirm/RESET",
  registerRequest: "signUp/REGISTER",
  registerSuccess: "signUp/REGISTER_SUCCESS",
  registerFailed: "signUp/REGISTER_FAILED",
  resetRegister: "signUp/RESET",
  resetPassword: "reset/PASSWORD",
  resetPasswordSuccess: "reset/PASSWORD_SUCCESS",
  resetPasswordFailed: "reset/PASSWORD_FAILED",
  profileRequest: "profile/PROFILE_REQUEST",
  profileSuccess: "profile/PROFILE_SUCCESS",
  profileFailed: "profile/PROFILE_FAILED",
  profileReset: "profile/RESET",
  updateProfile: "profile/UPDATE_PROFILE",
  regenerateKey: "profile/REGENERATE_KEY",
  updateProfileSuccess: "profile/UPDATE_PROFILE_SUCCESS",
  updateProfileFailed: "profile/UPDATE_PROFILE_FAILED",
  getProject: "project/GET_PROJECT",
  getProjectSuccess: "project/GET_PROJECT_SUCCESS",
  getProjectFailed: "project/GET_PROJECT_FAILED",
  generateSignedUrl: "profile/GENERATE_URL",
  generateSignedUrlError: "profile/GENERATE_URL_ERROR",
  changePassword: "password/CHANGE_PASSWORD",
  changePasswordSuccess: "password/CHANGE_PASSWORD_SUCCESS",
  changePasswordFailed: "password/CHANGE_PASSWORD_FAILED",
  resetChangePasswordData: "password/RESET",
  createProjectRequest: "createProject/CREATE_PROJECT",
  createProjectSuccess: "createProject/CREATE_PROJECT_SUCCESS",
  createProjectFailed: "createProject/CREATE_PROJECT_FAILED",
  searchMembers: "createProject/SEARCH_MEMBERS",
  searchMembersSuccess: "createProject/SEARCH_MEMBERS_SUCCESS",
  searchMembersFailed: "createProject/SEARCH_MEMBERS_FAILED",
  generateSignedUrlCreateProject: "createProject/GENERATE_URL",
  generateSignedUrlErrorCreateProject: "createProject/GENERATE_URL_ERROR",
  registerFirebaseDetails: "profile/FIREBASE",
  getProjectById: "project/GET_PROJECT_ID",
  getProjectByIdSuccess: "project/GET_PROJECT_ID_SUCCESS",
  getProjectByIdFailed: "project/GET_PROJECT_ID_FAILED",
  getProjectInfoById: "projectSetting/GET_PROJECT_ID",
  getProjectInfoByIdSuccess: "projectSetting/GET_PROJECT_ID_SUCCESS",
  getProjectInfoByIdFailed: "projectSetting/GET_PROJECT_ID_FAILED",
  generateSignedUrlUpdateProject: "updateProject/GENERATE_URL",
  generateSignedUrlErrorUpdateProject: "updateProject/GENERATE_URL_ERROR",
  updateProjectRequest: "updateProject/UPDATE_PROJECT",
  updateProjectSuccess: "updateProject/UPDATE_PROJECT_SUCCESS",
  updateProjectFailed: "updateProject/UPDATE_PROJECT_ERROR",
  archiveProject: "updateProject/ARCHIVE",
  archiveProjectSuccess: "updateProject/ARCHIVE_SUCCESS",
  archiveProjectFailed: "updateProject/ARCHIVE_ERROR",
  getNotifications: "project/GET_NOTIFICATIONS",
  getNotificationsSuccess: "project/GET_NOTIFICATIONS_SUCCESS",
  getNotificationsFailed: "project/GET_NOTIFICATIONS_FAILED",
  getUnreadNotificationsCount: "project/GET_UNREAD_NOTIFICATIONS_COUNT",
  getUnreadNotificationsCountSuccess:
    "project/GET_UNREAD_NOTIFICATIONS_COUNT_SUCCESS",
  notificationsMarkAsRead: "project/NOTIFICATIONS_MARK_AS_READ",
  notificationsMarkAsReadSuccess: "project/NOTIFICATIONS_MARK_AS_READ_SUCCESS",
  resetDataProject: "projectSetting/RESET",
  deleteMember: "projectSetting/DELETE",
  deleteMemberSuccess: "projectSetting/DELETE_SUCCESS",
  deleteMemberFailed: "projectSetting/DELETE_FAILED",
  resetProjectViewData: "projectView/RESET",
  getProjectMilestone: "projectView/GET_MILESTONE",
  getProjectMilestoneSuccess: "projectView/GET_MILESTONE_SUCCESS",
  getProjectMilestoneFailed: "projectView/GET_MILESTONE_FAILED",
  getMilestone: "project/GET_MILESTONE",
  getMilestoneSuccess: "project/GET_MILESTONE_SUCCESS",
  getMilestoneFailed: "project/GET_MILESTONE_FAILED",
  getMilestoneIssues: "project/GET_MILESTONE_ISSUES",
  getMilestoneIssuesSuccess: "project/GET_MILESTONE_ISSUES_SUCCESS",
  getMilestoneIssuesFailed: "project/GET_MILESTONE_ISSUES_FAILED",
  searchIssueMembers: "project/SEARCH_ISSUE_MEMBERS",
  searchIssueMembersSuccess: "project/SEARCH_ISSUE_MEMBERS_SUCCESS",
  searchIssueMembersFailed: "project/SEARCH_ISSUE_MEMBERS_FAILED",
  resetCreateData: "createProject/RESET",
  createMilestone: "createMilestone/CREATE_REQUEST",
  createMilestoneSuccess: "createMilestone/CREATE_SUCCESS",
  createMilestoneFailed: "createMilestone/CREATE_FAILED",
  getIssueDetails: "issue/GET_ISSUE_DETAILS",
  getIssueDetailsSuccess: "issue/GET_ISSUE_DETAILS_SUCCESS",
  getIssueDetailsFailed: "issue/GET_ISSUE_DETAILS_FAILED",
  createIssue: "issue/CREATE_ISSUE",
  createIssueSuccess: "issue/CREATE_ISSUE_SUCCESS",
  createIssueFailed: "issue/CREATE_ISSUE_FAILED",
  resetIssueReducer: "issue/RESET_ISSUE_REDUCER",
  updateMilestone: "createMilestone/UPDATE",
  updateMilestoneSuccess: "createMilestone/UPDATE_SUCCESS",
  updateMilestoneFailed: "createMilestone/UPDATE_SUCCESS",
  deleteMilestone: "viewMilestone/DELETE",
  deleteMilestoneSuccess: "viewMilestone/DELETE_SUCCESS",
  deleteMilestoneFailed: "viewMilestone/DELETE_FAILED",
  updateIssue: "issue/UPDATE_ISSUE",
  updateIssueSuccess: "issue/UPDATE_ISSUE_SUCCESS",
  updateIssueFailed: "issue/UPDATE_ISSUE_FAILED",
  getActivities: "activity/GET_ACTIVITIES",
  getActivitiesSuccess: "activity/GET_ACTIVITIES_SUCCESS",
  getActivitiesFailed: "activity/GET_ACTIVITIES_FAILED",
  deleteActivity: "activity/DELETE_ACTIVITY",
  deleteActivitySuccess: "activity/DELETE_ACTIVITY_SUCCESS",
  deleteActivityFailed: "activity/DELETE_ACTIVITY_FAILED",
  updateActivity: "activity/UPDATE_ACTIVITY",
  updateActivitySuccess: "activity/UPDATE_ACTIVITY_SUCCESS",
  updateActivityFailed: "activity/UPDATE_ACTIVITY_FAILED",
  deleteIssue: "issue/DELETE_ISSUE",
  deleteIssueSuccess: "issue/DELETE_ISSUE_SUCCESS",
  deleteIssueFailed: "issue/DELETE_ISSUE_FAILED",
  deleteMilestoneIssue: "milestone/DELETE_MILESTONE_ISSUE",
  addActivity: "activity/ADD_ACTIVITY",
  addActivitySuccess: "activity/ADD_ACTIVITY_SUCCESS",
  addActivityFailed: "activity/ADD_ACTIVITY_FAILED",
  editActivity: "activity/EDIT_ACTIVITY",
  editActivitySuccess: "activity/EDIT_ACTIVITY_SUCCESS",
  editActivityFailed: "activity/EDIT_ACTIVITY_FAILED",
  getPublicProject: "public/GET_PUBLIC_PROJECT",
  getPublicProjectSuccess: "public/GET_PUBLIC_PROJECT_SUCCESS",
  getPublicProjectFailed: "public/GET_PUBLIC_PROJECT_FAILED",
  getPublicMilestones: "public/GET_PUBLIC_MILESTONES",
  getPublicMilestonesSuccess: "public/GET_PUBLIC_MILESTONES_SUCCESS",
  getPublicMilestonesFailed: "public/GET_PUBLIC_MILESTONES_FAILED",
  getPublicIssues: "public/GET_PUBLIC_ISSUES",
  getPublicIssuesSuccess: "public/GET_PUBLIC_ISSUES_SUCCESS",
  getPublicIssuesFailed: "public/GET_PUBLIC_ISSUES_FAILED",
  getArchivedProjects: "archivedProjects/GET_PROJECTS",
  getArchivedProjectsSuccess: "archivedProjects/GET_PROJECTS_SUCCESS",
  getArchivedProjectsFailed: "archivedProjects/GET_PROJECTS_FAILED",
  unArchiveProject: "archivedProjects/UNARCHIVE",
  unArchiveProjectSuccess: "archivedProjects/UNARCHIVE_SUCCESS",
  unArchiveProjectFailed: "archivedProjects/UNARCHIVE_FAILED",
  deleteProjects: "archivedProjects/DELETE",
  deleteProjectsSuccess: "archivedProjects/DELETE_SUCCESS",
  deleteProjectsFailed: "archivedProjects/DELETE_FAILED",
  getProjectMembers: "projectSettings/GET_MEMBERS",
  getProjectMembersSuccess: "projectSettings/GET_MEMBERS_SUCCESS",
  getProjectMembersFailed: "projectSettings/GET_MEMBERS_FAILED",
  generatePublicUrl: "projectSettings/GENERATE_PUBLIC_URL",
  resetMileStoneData: "milestone/RESET",
  resetArchived: "archived/RESET",
  globalSearch: "GLOBAL_SEARCH",
  globalSearchSuccess: "search/GLOBAL_SEARCH_SUCCESS",
  globalSearchFailed: "search/GLOBAL_SEARCH_FAILED",
  clearGlobalSearch: "search/CLEAR_GLOBAL_SEARCH",
  getMilestoneActivityTimeline: "milestone/GET_MILESTONE_ACTIVITY_TIMELINE",
  getActivityTimelineRequest: "milestone/GET_ACTIVITY_TIMELINE_REQUEST",
  getActivityTimelineSuccess: "milestone/GET_ACTIVITY_TIMELINE_SUCCESS",
  getActivityTimelineFailed: "milestone/GET_ACTIVITY_TIMELINE_FAILED",
  resetActivityTimeline: "milestone/RESET_ACTIVITY_TIMELINE",
};

export default reducerConstant;
